import { gql } from "@apollo/client";

export default gql`
  query getRoleFrameworkStatus($organizationId: Int!) {
    careerTracks(organizationId: $organizationId, first: 1) {
      edges {
        node {
          id
        }
      }
    }
    competencies(organizationId: $organizationId, first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
`;
